import {appName} from "../config";

/**
 * Constants
 * */
export const moduleName = `serviceModal`;
const prefix = `${appName}/${moduleName}`;

export const OPEN_SERVICE_MODAL = `${prefix}/OPEN_SERVICE_MODAL`;
export const CLOSE_SERVICE_MODAL = `${prefix}/CLOSE_SERVICE_MODAL`;

/**
 * Reducer
 * */

export default function reducer(state = {}, action) {
  const {type} = action;

  switch (type) {
    case OPEN_SERVICE_MODAL:
      return {
        ...state,
        isOpen: true
      };

    case CLOSE_SERVICE_MODAL:
      return {
        ...state,
        isOpen: false
      };

    default:
      return state;
  }
}

/**
 * Selectors
 * */

export const serviceModalSelector = (state) => state[moduleName];

/**
 * Action Creators
 * */

export const openServiceModal = () => ({
  type: OPEN_SERVICE_MODAL
});

export const closeServiceModal = () => ({
  type: CLOSE_SERVICE_MODAL
});
